import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import LinkHandler from '../utils/LinkHandler'

const Wrapper = styled.div`
  width: 100%;
  background-image: url('${STATICS_PATH}images/plague/background.jpg');
  background-position: left;
  background-size: cover;
  box-sizing: border-box;
  font-family: Barlow, sans-serif;
  color: white;
  font-size: 14px;
  margin-bottom: 20px;
`

const MainBox = styled.div`
  display: flex;
  justify-content: space-evenly;
`

const MainBoxItem = styled.div`
  display: inline-flex;
  width: 50%;
  padding: 20px;
  flex-direction: column;
`

const Paragraph = styled.div`
  text-align: center;
  line-height: 1.2;

  &:not(:first-of-type) {
    margin-top: 10px;
  }
`

const Bold = styled.span`
  font-size: 18px;
  font-weight: bold;
  display: block;
  text-align: center;
`

const BoldForImage = styled(Bold)`
  margin: -28px auto 0 auto;
  z-index: 42;
  font-size: 17px;
  max-width: 245px;
  text-align: center;
  color: #fff;
  position: relative;
`

const AfterLinkImage = styled.img`
  background: #fff;
  width: 17px;
  padding: 4px;
  border-radius: 50%;
  vertical-align: middle;
  margin-left: 4px;
`

const InfoBox = styled.span`
  background: rgba(255,255,255,.1);
  color: #fff;
  border: 1px solid rgba(255,255,255,.2);
  border-radius: 3px;
  padding: 3px 6px;
  display: inline-block;
  margin: 3px;
  font-size: 12px;
  font-weight: bold;
  line-height: 15px;
`

const Link = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
  }
`

const MainBoxItemLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`

const ImageHolder = styled.div`
  text-align: center;
  position: relative;
  margin-top: 12px;
`

const Img = styled.img`
  width: 100%;
  opacity: .6;
`

const Articles = styled.div`
  display: flex;
  justify-content: space-evenly;
  background: rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  width: 100%;
`

const Article = styled.div`
  display: flex;
  padding: 15px 2%;
  font-size: 12px;
  line-height: 17px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  font-style: normal;
  
  &:not(:last-of-type) {
    border-right: 1px dashed rgba(255, 255, 255, 0.3);
  }
`

const ArticleLink = styled.a`
  color: inherit;
  text-decoration: none;
  
  &:hover {
    color: inherit;
  }
`

const ArticleImage = styled.img`
  border-radius: 50%;
  height: 40px;
  margin-right: 10px;
  float: left;
`

const ArticleText = styled.p`
  overflow: hidden;
  margin-bottom: 0;
`

const DataWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  max-width: 250px;
`

const DataItem = styled.div`
  display: block;
  flex-grow: 1;
  text-align: center;
  box-sizing: border-box;
  color: #fff;
`

const DataNumber = styled.h3`
  font-size: 25px;
  padding: 0;
  line-height: 23px;
`

const DataKey = styled.em`
  font-size: 14px;
  color: rgba(255,255,255,.7);
`

export default (props) => {
  const {
    widget: {
      utmSource,
      utmMedium,
      boxes
    }
  } = props
  const mainBoxUrl = 'https://zpravy.aktualne.cz/domaci/pocty-nakazenych-v-krajich/r~c68291be683f11ea9d74ac1f6b220ee8/'
  const mainBoxLink = new LinkHandler(mainBoxUrl).mergeUTMParams({ utmSource, utmMedium, utmContent: 'covid' }).link
  const [ articles, [ stats ] ] = _.partition(boxes, { source: 'BbxCoronavirus' })

  return (
    <Wrapper>
      <MainBox>
        <MainBoxItem>
          <Paragraph>
            Informace <Bold>o KORONAVIRU</Bold>
          </Paragraph>
          <Paragraph>
            V případě zdravotních obtíží volejte linku <InfoBox>1212</InfoBox> nebo svého praktického lékaře.
          </Paragraph>
          <Paragraph>
            Nonstop linka - Státní zdravotní ústav:<br/>
            <InfoBox>725 191 370</InfoBox>
            <InfoBox>724 810 106</InfoBox>
            <InfoBox>725 191 367</InfoBox>
          </Paragraph>
          <Paragraph>
            Kde hledat informace:<br/>
            <InfoBox><Link href='http://www.szu.cz'>www.szu.cz</Link></InfoBox>
            <InfoBox><Link href='http://www.mzcr.cz'>www.mzcr.cz</Link></InfoBox>
          </Paragraph>
        </MainBoxItem>
        <MainBoxItem>
          <MainBoxItemLink href={mainBoxLink}>
            <ImageHolder>
              <Img src='https://graphics.stdout.cz/2dfd0791577ee1244b06632d98213259/mapa-cz._115_.png' alt='mapa'/>
              <DataWrapper>
                <DataItem>
                  <DataNumber>{ stats.countSick }</DataNumber>
                  <DataKey>nakažených</DataKey>
                </DataItem>
                <DataItem>
                  <DataNumber>{ stats.countRecover }</DataNumber>
                  <DataKey>uzdravených</DataKey>
                </DataItem>
                <DataItem>
                  <DataNumber>{ stats.countDead }</DataNumber>
                  <DataKey>úmrtí</DataKey>
                </DataItem>
              </DataWrapper>
            </ImageHolder>
            <BoldForImage>
              Počty nakažených v ČR podle krajů a další statistiky
              <AfterLinkImage src='https://graphics.stdout.cz/2dfd0791577ee1244b06632d98213259/arrow-right-blue._142_.svg'/>
            </BoldForImage>
          </MainBoxItemLink>
        </MainBoxItem>
      </MainBox>
      <Articles>
        {
          articles.map(({ link, images, title }, index) => (
            <Article key={index}>
              <ArticleLink href={new LinkHandler(link).mergeUTMParams({ utmSource, utmMedium, utmContent: 'covid' }).link}>
                <ArticleImage src={images['1_1']}/>
                <ArticleText>{title}</ArticleText>
              </ArticleLink>
            </Article>
          ))
        }
      </Articles>
    </Wrapper>
  )
}
